import { CORE_API } from "../constants";
import { getData } from "./common.service";
interface TFertilizerOption {
    fertilizer: string;
    id: string;
    amount: string;
    unit: string;
}
  
interface TNutrient {
    name: string;
    amount: string;
    unit: string;
}

interface TMetadata {
    fertigationStage: string;
    fertigationWeek: number;
    fertigationType: string;
    nutrients: TNutrient[];
    sources: TFertilizerOption[][];
}
interface TSprayOption {
  id: string;
  amount: number;
  unit: string;
  displayName: string;
}
export interface TFarmActivity {
    created_date: string;
    id: string;
    notes: string;
    suggested: boolean;
    rejected: boolean;
    done: boolean;
    suggestedDate: string;
    doneDate?: string;
    baseStage: string;
    daysAfterBaseStage: string;
    fertilizerOptions: TFertilizerOption[][];
    metadata: TMetadata;
    plotId: string;
    farmActivityTypeId: string;
    cropId: string;
    sprayOptions?: TSprayOption[][];
}

class FarmActivitiesService {  

  private static readonly baseUrl = "/farm-activities/";

  static getPlotAcitivities(plotId: string, offset: number): Promise<TFarmActivity[]> {
    const filterQuery = {
      skip: offset,
      limit: 10,
    };
    const url = `${FarmActivitiesService.baseUrl}${plotId}/list?filter=${JSON.stringify(
      filterQuery
    )}`;

    return getData(url, {
      sendTokenInHeader: true,
      basePath: CORE_API,
    });
  } 

}

export default FarmActivitiesService;